'use strict';

/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */
  var defaultSettings = {
    method: 'scroll',
  	container: '#AjaxinateContainer',
  	pagination: '#AjaxinatePagination',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  this.destroy = this.destroy.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.handleBack = async function handleBackButtonClicks() {
  let storedData = JSON.parse(window.localStorage.getItem('b_info'));
  let storedPage = parseInt(storedData.pagination_page);
  // return if only on page 1
  if(storedPage <= 1) return;
  let products = document.querySelectorAll('.rm-product-grid-item');
  let productsPaged = parseInt(this.containerElement.dataset.productsPaged);
  // return if products match
  if(products.length != (storedPage * productsPaged)) {
    var loadedPage = 1;
    var dummyEvent = {
      preventDefault() {
        return true;
      }
    }
    while(loadedPage < storedPage) {
      this.clickActive = true;
      await this.stopMultipleClicks(dummyEvent);
      loadedPage++;
    }
  }
  if(storedData.previous_scroll_depth != null && storedData.previous_scroll_depth > 0 && window.scrollY != storedData.previous_scroll_depth) {
    window.scrollTo({ top: storedData.previous_scroll_depth, behaviour: 'instant' });
  }
}

Ajaxinate.prototype.storePagination = function storePageDataForBackUsage() {
  let storedData;
  let nextPage = parseInt(this.nextPageLinkElement.dataset.currentPage) + 1;
  // window.history.pushState({ page: nextPage }, document.title, this.nextPageLinkElement.href);
  if(window.localStorage.getItem('b_info') == null) {
    storedData = {
      'page_url': null,
      'previous_scroll_depth': null,
      'scroll_depth': null,
      'pagination_page': nextPage
    };
  } else {
    storedData = JSON.parse(window.localStorage.getItem('b_info'));
    storedData['pagination_page'] = nextPage;
  }
  window.localStorage.setItem('b_info', JSON.stringify(storedData));
}

Ajaxinate.prototype.initialize = async function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = async function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerText = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.storePagination();
    await this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerText = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = async function getTheHtmlOfTheNextPageWithAnAjaxRequest() {

  const pageUrl = this.nextPageUrl.indexOf('?') > -1 ? this.nextPageUrl + '&view=paginated-get' : this.nextPageUrl + '?view=paginated-get';
  const response = await fetch(pageUrl, {
    method: 'GET',
    credentials: 'same-origin',
    keepalive: true,
    redirect: 'follow',
    headers: {
      Accept: 'text/html',
    },
  });

  const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

  const nextPageItemsContainer = doc.querySelectorAll(this.settings.container)[0];
  const nextPagePaginationContainer = doc.querySelectorAll(this.settings.pagination)[0];

  if (!nextPageItemsContainer) {
    return;
  }

  const rmProductsContainer = document.querySelector('.rm-product-grid');
  const rmNextPageProductsContainer = nextPageItemsContainer.querySelector('.rm-product-grid');
  rmProductsContainer.insertAdjacentHTML('beforeend', rmNextPageProductsContainer.innerHTML);

  if (!nextPagePaginationContainer) {
    document.querySelector(this.settings.pagination).innerHTML = '';
  } else {
    document.querySelector(this.settings.pagination).innerHTML = nextPagePaginationContainer.innerHTML
    if(typeof ratingSnippet != 'undefined') {
      ratingSnippet("ruk_rating_snippet", {
        store: "www.kukoonrugs.com",
        mode: "default",
        color: "#333333",
        linebreak: false,
        text: "Reviews",
        singularText: "Review",
        lang: "en",
        usePolaris: false,
        showEmptyStars: true,
      });
    }
  }

  if(typeof window.addEventAlternateHover != 'undefined') window.addEventAlternateHover();

  // RM - Re initialize product card swipers when new products are loaded via pagination
  if (window.productCardSwiper && typeof window.productCardSwiper.reinit === 'function') {
    window.productCardSwiper.reinit();
  }

  this.initialize()
  
}

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};